export function queryAction(command, REQUEST, SUCCESS, ERROR) {
    return { run };

    function run(dispatch) {
        dispatch({
            type: REQUEST,
            payload: {},
        });
        resolvedPromise(command)
            .then(data => {
                dispatch({ type: SUCCESS, payload: data });
            })
            .catch(err => {
                dispatch({ type: ERROR, payload: err });
            });
    }
}

export function resolvedPromise(promise) {
    return promise.then(res => res);
}
